<template>
  <form>
    <div class="two-column-form-container usb-form-container">
      <div class="wd-50">
        <div class="select-control">
          <select
            v-model.trim="$v.usbProduct.$model"
            class="full-width"
            id="usbProduct"
            :class="{
              'error-select':
                $v.usbProduct.$errors && $v.usbProduct.$errors.length > 0,
            }"
            @change="usbProductChanged($v.usbProduct)"
            @blur="$v.usbProduct.$touch"
            aria-describedby="usbProduct-error"
            aria-required="true"
            :aria-invalid="$v.usbProduct.$errors.length > 0"
          >
            <option
              v-for="usbProduct in usbProducts"
              :key="usbProduct"
              :value="usbProduct"
            >
              {{ usbProduct }}
            </option>
          </select>
          <label
            for="usbProduct"
            class="select-label"
            :class="{
              'error-select-label':
                $v.usbProduct.$errors && $v.usbProduct.$errors.length > 0,
            }"
            >Microchip USB Product</label
          >
          <span class="required">*</span>
        </div>
        <div
          class="input-errors" id="usbProduct-error" aria-live="assertive" aria-relevant="all"
        >
          <div class="error-msg" v-for="(error, index) of $v.usbProduct.$errors"
          :key="index">{{ error.$message }}</div>
        </div>
      </div>
      <div class="wd-45">
        <div class="text-control">
          <input
            type="text"
            id="productNumber"
            class="text-input flex-fill"
            :class="{
              'error-text-control':
                $v.productNumber.$errors && $v.productNumber.$errors.length > 0,
            }"
            v-model.trim="$v.productNumber.$model"
            @input="formValueChanged($v.productNumber)"
            @blur="$v.productNumber.$touch"
            aria-describedby="productNumber-error"
            aria-required="true"
            :aria-invalid="$v.productNumber.$errors.length > 0"
          />
          <label
            for="productNumber"
            class="text-label desktop"
            :class="{
              'error-label':
                $v.productNumber.$errors && $v.productNumber.$errors.length > 0,
            }"
            >Your product model name/number</label
          >
          <label
            for="productNumber"
            class="text-label mobile"
            :class="{
              'error-label':
                $v.productNumber.$errors && $v.productNumber.$errors.length > 0,
            }"
            >Product model name</label
          >
          <span class="required">*</span>
        </div>
        <div
          class="input-errors" id="productNumber-error" aria-live="assertive" aria-relevant="all"
        >
          <div class="error-msg" v-for="(error, index) of $v.productNumber.$errors"
          :key="index">{{ error.$message }}</div>
        </div>
      </div>
    </div>
    <div class="two-column-form-container">
      <div class="wd-50">
        <div class="margin-top-15">
          <fieldset role="radiogroup">
            <label class="individual-label desktop wd-auto"
            :class="{
              'error-label': $v.USBIFCert.$errors && $v.USBIFCert.$errors.length > 0,
            }"
            tabindex="0"
            >Are you planning on requesting a USBIF Certification?</label
            >
            <label class="individual-label mobile"
            :class="{
              'error-label': $v.USBIFCert.$errors && $v.USBIFCert.$errors.length > 0,
            }"
            tabindex="0"
            >Request USBIF Certification?</label
            >
            <div class="inline">
              <div class="radio-control" role="radio">
                <input
                type="radio"
                id="USBIFCertYes"
                name="USBIFCert"
                class="radio-input"
                value="yes"
                v-model.trim="$v.USBIFCert.$model"
                @change="USBIFCertChanged($v.USBIFCert)"
                @blur="$v.USBIFCert.$touch"
                aria-describedby="USBIFCert-error"
                aria-required="true"
                :aria-invalid="$v.USBIFCert.$errors.length > 0"
                />
                <label for="USBIFCertYes" class="label-radio">YES</label>
              </div>
              <div class="radio-control" role="radio">
                <input
                  type="radio"
                  id="USBIFCertNo"
                  name="USBIFCert"
                  class="radio-input"
                  value="no"
                  v-model.trim="$v.USBIFCert.$model"
                  @change="USBIFCertChanged($v.USBIFCert)"
                  @blur="$v.USBIFCert.$touch"
                />
                <label for="USBIFCertNo" class="label-radio">NO</label>
              </div>
              <span class="required">*</span>
            </div>
          </fieldset>
        </div>
        <div
          class="input-errors" id="USBIFCert-error" aria-live="assertive" aria-relevant="all"
        >
          <div class="error-msg" v-for="(error, index) of $v.USBIFCert.$errors"
          :key="index">{{ error.$message }}</div>
        </div>
      </div>
      <div class="wd-45">
        <div class="margin-top-15" v-if="isUSBIFCert">
          <fieldset role="radiogroup">
            <label class="individual-label desktop wd-auto"
              :class="{
                'error-label': $v.vid.$errors && $v.vid.$errors.length > 0,
              }"
              tabindex="0"
              >Do you have your own VID?</label
            >
            <label class="individual-label mobile"
              :class="{
                'error-label': $v.vid.$errors && $v.vid.$errors.length > 0,
              }"
              tabindex="0"
              >Have your own VID?</label>
            <div class="inline">
              <div class="radio-control" role="radio">
                <input
                  type="radio"
                  id="VIDYes"
                  name="VID"
                  class="radio-input"
                  value="yes"
                  v-model.trim="$v.vid.$model"
                  @change="formValueChanged($v.vid)"
                  @blur="$v.vid.$touch"
                />
                <label for="VIDYes" class="label-radio" tabindex="0">YES</label>
              </div>
              <div class="radio-control" role="radio">
                <input
                  type="radio"
                  id="VIDNo"
                  name="VID"
                  class="radio-input"
                  value="no"
                  v-model.trim="$v.vid.$model"
                  @change="formValueChanged($v.vid)"
                  @blur="$v.vid.$touch"
                  aria-describedby="vid-error"
                  aria-required="true"
                  :aria-invalid="$v.vid.$errors.length > 0"
                />
                <label for="VIDNo" class="label-radio" tabindex="0">NO</label>
              </div>
              <span class="required">*</span>
            </div>
          </fieldset>
        </div>
        <div
          class="input-errors" id="vid-error" aria-live="assertive" aria-relevant="all"
        >
          <div class="error-msg" v-for="(error, index) of $v.vid.$errors"
          :key="index">{{ error.$message }}</div>
        </div>
      </div>
    </div>
    <div class="two-column-form-container">
      <div class="wd-50">
        <div class="margin-top-15" v-if="showPID">
          <fieldset role="radiogroup">
            <label class="individual-label desktop wd-auto"
            :class="{
              'error-label': $v.pid.$errors && $v.pid.$errors.length > 0,
            }"
            tabindex="0"
            >Do you have your own PID?</label
          >
            <label class="individual-label mobile"
              :class="{
                'error-label': $v.pid.$errors && $v.pid.$errors.length > 0,
              }"
              tabindex="0"
              >Have your own PID?</label>
            <div class="inline">
              <div class="radio-control" role="radio">
                <input
                  type="radio"
                  id="PIDYes"
                  name="PID"
                  class="radio-input"
                  value="yes"
                  v-model.trim="$v.pid.$model"
                  @change="formValueChanged($v.pid)"
                  @blur="$v.pid.$touch"
                  aria-describedby="pid-error"
                  aria-required="true"
                  :aria-invalid="$v.pid.$errors.length > 0"
                />
                <label for="PIDYes" class="label-radio" tabindex="0">YES</label>
              </div>
              <div class="radio-control" role="radio">
                <input
                  type="radio"
                  id="PIDNo"
                  name="PID"
                  class="radio-input"
                  value="no"
                  v-model.trim="$v.pid.$model"
                  @change="formValueChanged($v.pid)"
                  @blur="$v.pid.$touch"
                />
                <label for="PIDNo" class="label-radio" tabindex="0">NO</label>
              </div>
              <span class="required">*</span>
            </div>
          </fieldset>
        </div>
        <div
          class="input-errors" id="pid-error" aria-live="assertive" aria-relevant="all"
        >
          <div class="error-msg" v-for="(error, index) of $v.pid.$errors"
          :key="index">{{ error.$message }}</div>
        </div>
      </div>
      <div class="wd-45"></div>
    </div>
    <div class="margin-top-20">
      <p class="text">
        Briefly describe what the license will be used for<span class="required"
          >*</span
        >
      </p>
      <textarea
        class="text-area"
        rows="5"
        placeholder="Briefly describe what the license will be used for"
        v-model.trim="$v.description.$model"
        :class="{
          'error-text-area':
            $v.description.$errors && $v.description.$errors.length > 0,
        }"
        @input="formValueChanged($v.description)"
        @blur="$v.description.$touch"
        aria-describedby="description-error"
        aria-required="true"
        :aria-invalid="$v.description.$errors.length > 0"
        aria-label="Briefly describe what the license will be used for"
      ></textarea>
      <div
        class="input-errors" id="description-error" aria-live="assertive" aria-relevant="all"
      >
        <div class="error-msg" v-for="(error, index) of $v.description.$errors"
        :key="index">{{ error.$message }}</div>
      </div>
    </div>
  </form>
</template>
<script>
import {reactive, computed} from "vue";
import {useVuelidate} from "@vuelidate/core";
import {requiredIf} from "@vuelidate/validators";

export function isFilled(word) {
  if (word){
    return true;
  }
  return false;
}

export default {
  props: ["usbProducts"],
  emits: ["usbDataChanged"],
  setup(props, context) {
    const form = reactive({
      usbProduct: null,
      USBIFCert: null,
      productNumber: "",
      vid: null,
      pid: null,
      description: "",
    });

    const rules = {
      usbProduct: { 
        required: {
          $validator: isFilled,
          $message: 'Please select a USB Product.'
        },
      },
      USBIFCert: {
        required: {
          $validator: isFilled,
          $message: 'Please select an option.'
        },
      },
      productNumber: {
        required: {
          $validator: isFilled,
          $message: 'Please fill in the product number.'
        },
      },
      vid: { required: requiredIf(function() {
        return form.USBIFCert === "yes";
      }) },
      pid: { required: requiredIf(function() {
        return form.USBIFCert === "yes" && !isMicrochipProduct(form.usbProduct);
      }) },
      description: {
        required: {
          $validator: isFilled,
          $message: 'Please fill in the description.'
        },
      },
    };

    const isUSBIFCert = computed(function () {
      return form.USBIFCert === "yes";
    });

    const showPID = computed(function () {
      return form.USBIFCert === "yes" && form.usbProduct && !isMicrochipProduct(form.usbProduct);
    });

    const $v = useVuelidate(rules, form);
    function formValueChanged(ref, changedRef=null) {
      ref.$touch;
      context.emit("usbDataChanged", {
        usbProduct: form.usbProduct,
        USBIFCert: form.USBIFCert,
        productNumber: form.productNumber,
        vid: form.vid,
        pid: form.pid,
        description: form.description,
        isFormInvalid: $v._value.$errors.length > 0 || $v._value.$silentErrors.length > 0,
        ref: changedRef,
      });
    }
    function isMicrochipProduct(product) {
      const mchpPattern = 'PIC,DSPIC,MCP,AT,SAM'.split(',');
      for (let i = 0; i < mchpPattern.length; i++) {
          if (product?.toUpperCase().match("^" + mchpPattern[i])) {
              return true;
          }
      }
      return false;
    }

    function usbProductChanged(ref) {   
      form.USBIFCert = null;
      form.vid = null;
      form.pid = null;
      formValueChanged(ref,'usbProduct');
    }

    function USBIFCertChanged(ref) {
      form.vid = null;
      form.pid = null;
      formValueChanged(ref,'usbIF');
    }

    return {
      form,
      $v,
      isUSBIFCert,
      showPID,
      usbProductChanged,
      USBIFCertChanged,
      formValueChanged,
    };
  },
};
</script>
<style scoped>
  .inline {
    display: inline-block;
  }
</style>